import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './header.component';
import { FooterComponent } from './footer.component';
import { ContactComponent } from './contact.component';
import { CallMeBackComponent } from './callmeback.component';
import { RouterModule } from '@angular/router';
import { NumericFieldDirective } from '../helpers/directive/numeric-field.directive';
import { TrackingDirective } from '../helpers/directive/tracking.directive';
import { PasswordStrengthBar } from '../helpers/components/password-strength-bar';
import { PasswordStrengthCheck } from '../helpers/components/password-strength-check';
import { FormatTimePipe } from '../helpers/pipe/format-time.pipe';
import { TitleCasePipe } from '../helpers/pipe/title-case.pipe';
import { PostRegisterFooterComponent } from './post-register-footer.component';
import { AfterLoginFooterComponent } from "./afterLoginFooter.component";

import { CreditLifeDesktopBenefitsDrawerComponent } from '../cover-folder/credit-life/Benefits/desktop-benefits-drawer/creditLifeDesktopBenefitsDrawer.component';
import { CreditLifeDesktopPremiumDrawerComponent} from '../cover-folder/credit-life/Premium/desktop-premium-drawer/creditLifeDesktopPremiumDrawer.component';
import { CreditLifeMobilePremiumDrawerComponent } from '../cover-folder/credit-life/Premium/mobile-premium-drawer/creditLifeMobilePremiumDrawer.component';
import { CreditLifeMobileBenefitsDrawerComponent } from '../cover-folder/credit-life/Benefits/mobile-benefits-drawer/creditLifeMobileBenefitsDrawer.component';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, CallMeBackComponent, HeaderComponent, FooterComponent, ContactComponent, 
        NumericFieldDirective, TrackingDirective,PasswordStrengthBar,PasswordStrengthCheck, FormatTimePipe 
        , AfterLoginFooterComponent,PostRegisterFooterComponent, CreditLifeDesktopBenefitsDrawerComponent, CreditLifeMobileBenefitsDrawerComponent, 
        CreditLifeDesktopPremiumDrawerComponent, CreditLifeMobilePremiumDrawerComponent, TitleCasePipe],
    exports: [CallMeBackComponent, HeaderComponent, FooterComponent, ContactComponent,
         CommonModule, FormsModule, ReactiveFormsModule, NumericFieldDirective, TrackingDirective,PasswordStrengthBar,
         PasswordStrengthCheck, FormatTimePipe, TitleCasePipe
         , AfterLoginFooterComponent, PostRegisterFooterComponent, CreditLifeDesktopBenefitsDrawerComponent, CreditLifeMobileBenefitsDrawerComponent, 
         CreditLifeDesktopPremiumDrawerComponent, CreditLifeMobilePremiumDrawerComponent ]

})
export class SharedModule { }
